import { render, staticRenderFns } from "./tReports.vue?vue&type=template&id=539e1074&scoped=true"
import script from "./tReports.vue?vue&type=script&lang=js"
export * from "./tReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e1074",
  null
  
)

export default component.exports